import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Subscriber Metadata ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Add or update inverter ID:", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Inverter ID:")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_meta_data_component = _resolveComponent("meta-data-component")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      (_ctx.subscriberMetadata)
                        ? (_openBlock(), _createBlock(_component_meta_data_component, {
                            key: 0,
                            data: _ctx.subscriberMetadata,
                            horizontal: false,
                            editable: true
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("form", {
                        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
                      }, [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, null, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_row, { style: {"flex-grow":"1"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _hoisted_3
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.form.inverterId,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.inverterId) = $event)),
                                      name: "inverterId",
                                      id: "inverterId"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, { type: "submit" }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 32)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}